module.exports = {
  __init__: [ 'changeSupport'],
  changeSupport: [ 'type', require(146) ]
};